import { render } from "./RelatedApartments.vue?vue&type=template&id=7c9f8ef9&scoped=true"
import script from "./RelatedApartments.vue?vue&type=script&lang=js"
export * from "./RelatedApartments.vue?vue&type=script&lang=js"

import "./RelatedApartments.vue?vue&type=style&index=0&id=7c9f8ef9&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9f8ef9"]])

export default __exports__